
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"4","height":"10","rx":"2","fill":"#6E88F3"}}),_c('rect',{attrs:{"x":"10","width":"4","height":"10","rx":"2","fill":"#6E88F3"}}),_c('rect',{attrs:{"x":"20","width":"4","height":"10","rx":"2","fill":"#6E88F3"}})])
          )
        }
      }
    